module.exports = __webpack_public_path__ + "img/zoomin.490f74aa.svg";